module.exports = __webpack_public_path__ + "img/领先的IOT平台化能力.100a2f7e.png";